import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import PageWrapper from '@/components/layout/PageWrapper';
import { Button } from '@/components/ui/button';
import POForm from '@/components/orderedParts/POForm';

export default function ThirdPartyRepair() {
  const navigate = useNavigate();

  return (
    <PageWrapper
      title="3rd Party / Standalone Repair"
      subtitle="Submit a part order or third-party repair not linked to a specific repair request"
      actions={
        <Button variant="outline" onClick={() => navigate('/ordered-parts')}>
          <ArrowLeft className="mr-2 h-4 w-4" />
          Back
        </Button>
      }
    >
      <div className="max-w-2xl">
        <POForm
          onSuccess={() => navigate('/ordered-parts')}
          onCancel={() => navigate(-1)}
        />
      </div>
    </PageWrapper>
  );
}
